import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'tr_TR',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '5dfce97d-5270-4788-95aa-19640633dcd2',
  ''
);
